import {
    EXTERNAL_SIGNATURE_PROVIDER_KEYS,
    SIGNATURE_PROVIDERS,
    type SignatureProvider,
} from "config/signatureProviders";
import { IntegrationStatus } from "store/integrationsStore";
import { useAppSelector } from "store/store";

export const useActiveSignProvider = (): SignatureProvider => {
    const integrations = useAppSelector((state) => state.integrations.integrations);

    const activeExternalKey = EXTERNAL_SIGNATURE_PROVIDER_KEYS.find((key) =>
        integrations.some((i) => i.partner === key && i.status === IntegrationStatus.CONNECTED),
    );

    return activeExternalKey ? SIGNATURE_PROVIDERS[activeExternalKey] : SIGNATURE_PROVIDERS.crealo_sign;
};
